// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1WZCM","errors":"Errors_errors__G4xXp"};